import React, { FC, useCallback, useEffect, useState, useContext, useMemo } from 'react';
import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';

import { get, post } from "../fetchers/fetchers";
import { get_query } from '../stateManagement/data';

import { useParams } from "react-router";

import {
    Accordion, AccordionSummary, Chip,
    Container, Grid, IconButton, Paper,
    Table, TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
    TextField,
    withStyles
} from "@material-ui/core";
import {
    IAdequacy,
    IControlMeasure, IControlMeasureAdequacy, IControlMeasureAssessment, IControlMeasureCost,
    IControlMeasureFailureMode,
    IControlType, ICriticalHazards, IFailureModeAssessment, IHarm,
    IProjectFailureMode,
    IRiskAssessment
} from "../types/types";

import WarningIcon from '@material-ui/icons/Warning';

import { APPLICATION } from "../env";
import { API_URL } from "../env";
import { RenderCategory } from './reasonably_praticable_category';


export const WarningChip = (name: string, inital_level?: number, tool_tip_label?: string) => {

    let level = -1;
    if (inital_level) {
        level = inital_level;
    }
    let alpha = 1
    let color = "#535353"
    let bcolor = "rgb(196,196,196)";
    if (level) {
        if (level === 4) {
            bcolor = "rgba(0,176,80," + alpha + ")";
            color = "rgb(0,0,0)";

        }
        if (level === 3) {
            bcolor = "rgba(206,238,208," + alpha + ")";
            color = "rgb(48,104,33)";

        }
        if (level === 2) {
            bcolor = "rgba(252,236,166," + alpha + ")";
            color = "rgb(152,96,34)";

        }
        if (level === 1) {
            bcolor = "rgba(251,84,81," + alpha + ")";
            color = "rgb(104,4,0)";

        }

    }


    if (tool_tip_label === undefined) {
        tool_tip_label = "Not enough data for assessment"
    }


    return (
        <div>
            <Tooltip title={tool_tip_label}>
                <Chip
                    icon={<WarningIcon />}
                    size="small"
                    label={name}
                    color="primary"
                    style={{ backgroundColor: bcolor, color: color }}
                />
            </Tooltip>
        </div>
    )
}

interface IControlMeasureAssessmentsProps {
    existing: boolean,
    considered: boolean,
    additional: boolean,
    control_view?: boolean
}

interface IRouteParams {
    id: string
}



const ReasonablyPracticable: FC<IControlMeasureAssessmentsProps> = ({ existing, considered, additional, control_view=false }) => {

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [controlTypes, setControlTypes] = useState<IControlType[]>([]);
    const [controlMeasures, setControlMeasures] = useState<IControlMeasure[]>([]);
    const [adequacies, setAdequacies] = useState<IAdequacy[]>([]);
    const [failureModes, setFailureModes] = useState<IProjectFailureMode[]>([]);
    const [controlMeasureAssessments, setControlMeasureAssessments] = useState<IControlMeasureAssessment[]>([]);
    const [controlMeasureFailureModes, setControlMeasureFailureModes] = useState<IControlMeasureFailureMode[]>([]);
    const [harms, setHarms] = useState<IHarm[]>([]);
    const [riskAssessments, setRiskAssessments] = useState<ICriticalHazards[]>([]);
    const [controlMeasureAdequacies, setControlMeasureAdequacies] = useState<IControlMeasureAdequacy[]>([]);
    const [controlMeasureConcerns, setControlMeasureConcerns] = useState<IControlMeasureAdequacy[]>([]);
    // const [controlMeasureCosts, setControlMeasureCosts] = useState<IControlMeasureCost[]>([]);
    const [failureModeAssessments, setFailureModeAssessments] = useState<IFailureModeAssessment[]>([]);
    const [write_access, setWriteAccess] = useState<boolean>(false);


    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()


    useEffect(() => {
        if (tasks.loaded) {
            // only add active failure modes
            let active = tasks.failureModes.filter(fm => fm.failure_mode?.is_active === true)

            setFailureModes(active);
        }
    }, [tasks.failureModes, tasks.loaded]);

    useEffect(() => {
        if (tasks.loaded) {
            setFailureModeAssessments(tasks.failureModeAssessments);
        }
    }, [tasks.failureModeAssessments, tasks.loaded]);


    useEffect(() => {
        if (tasks.loaded) {
            setControlMeasureFailureModes(tasks.failureModeControlMeasures);
        }
    }, [tasks.failureModeControlMeasures, tasks.loaded]);


    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks.write_access])

    const params = useParams<IRouteParams>()

    const [expanded, setExpanded] = React.useState<string | false>(false);

    const handleChange = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };


    const filteredFailureModes = useMemo<IProjectFailureMode[]>(
        () => {

            if (!additional) {
                let filtered = failureModes.filter(fm => {
                    const fma = failureModeAssessments.find(fma => fma.project_failure_mode_id === fm.id);
                    if (considered === false && fma && fma.consider) return false;
                    return fma && fma.consider === true;

                })
                return filtered;
            }
            let filtered = failureModes.filter(fm => {
                const fma = failureModeAssessments.find(fma => fma.project_failure_mode_id === fm.id);
                if (fma && fma.consider) return false;
                return  true;

            })
            return filtered
        }  , [failureModes, failureModeAssessments, considered]);


    return (

        <Grid container xs={12} lg={12} style={{ padding: 10, width: "100%" }}>
            <Paper variant={"outlined"}
                style={{ display: "flex", flexDirection: "column", height: "100%", margin: "10px", flex: 1 }}>
                {filteredFailureModes.map(fm => (
                    <RenderCategory
                        key={fm.id}
                        f={fm}
                        handleChange={handleChange}
                        expanded={expanded}
                        existing={existing}
                        considered={considered}
                        additional={additional}
                        control_view={control_view}
                    />
                ))}
                {!additional &&
                    <div>
                        <Typography><small>Note only included group failure modes are shown</small></Typography>
                    </div>
                }

                {additional &&
                    <div>
                        <Typography><small>Note only not included group failure modes are shown</small></Typography>
                    </div>
                }
            </Paper>
        </Grid>


    );
}

export default ReasonablyPracticable;

